export var getWindowOffsetTop = function getWindowOffsetTop() {
  return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
};
export var getWindowOffsetLeft = function getWindowOffsetLeft() {
  return (window.pageXOffset || document.documentElement.scrollLeft) - (document.documentElement.clientLeft || 0);
};
export var getViewportHeight = function getViewportHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
};
export var getAllFocusableElementsByContainer = function getAllFocusableElementsByContainer(container) {
  return container.querySelectorAll('button:not([disabled]):not(.disabled), [href]:not(.disabled), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
};
export var getElementMeasurements = function getElementMeasurements(elem) {
  return elem ? elem.getBoundingClientRect() : {};
};